import React, { useEffect, useState } from "react";
import { initialFormData, useForm } from "../context/Form/FormContext";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import SpinnerModal from "../../Utils/Spinner/Spinner";
import { useInput } from "../context/InputGlobal/InputContext";
import swal from "sweetalert";
import StyledLabel from "../Label/StyledLabel";
import { useToast } from "../context/ToastContext";
import { AutoCompleteClient } from "../AutoComplete/AutoCompleteClient";
import { AutoCompleteProduct } from "../AutoComplete/AutoCompleteProduct";
import { jwtDecode } from "jwt-decode";
import Cleave from "cleave.js/react";
import { FaSearchIcon } from "../../pages/OCRPage";
import { checkJourneyExists } from "../../services/journeyService";
import { formatPhone } from "../../Utils/formatPhone";

type DeliveryMode = "sms" | "whatsapp" | "screen";

const ConsultForm: React.FC = () => {
  const { formData, setFormData } = useForm();
  const showToast = useToast();
  const [file, setFile] = useState<File | null>(null);

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [protocol, setProtocol] = useState("");
  const [clientName, setClientName] = useState("");
  const [selectedClient, setSelectedClient] = useState<any | null>(null);
  const [productName, setProductName] = useState("");
  const [selectedProduct, setSelectedProduct] = useState<any | null>(null);
  const [isApto, setIsApto] = useState<string | null>(null);
  const [creditCardLimit, setCreditCardLimit] = useState<string | null>(null);
  const [reasonRejected, setReasonrejected] = useState<string | null>(null);
  const [isAptoPartners, setIsAptoPartners] = useState<any | null>(null);
  const [mensagemAtencao, setMensagemAtencao] = useState<string | null>(null);
  const [loadingTel, setLoadingTel] = useState(false);
  const [loadingPhone, setLoadingPhone] = useState(false);
  const [phoneChecked, setPhoneChecked] = useState(false);
  const [hotlineResults, setHotlineResults] = useState<{ [cpf: string]: string }>({});
  const [useJourney, setUseJourney] = useState<boolean | null>(null);
  const [showSelectModal, setShowSelectModal] = useState(false);
  const [phoneWarnings, setPhoneWarnings] = useState<string[]>([]);

  const [showLinkModal, setShowLinkModal] = useState(false);
  const [generatedLink, setGeneratedLink] = useState<string | null>(null);

  const { inputValue } = useInput();

  interface ApiErrorResponse {
    instance: string;
    status: number;
    title?: string;
    errors: {
      [key: string]: string[];
    };
  }

  const FRONT_BASE_URL = "https://portaldemo.4axon.tec.br".replace(/\/+$/, "");

  function toFullLink(link: string) {
    if (!link) return "";
    if (/^https?:\/\//i.test(link)) return link;
    return `${FRONT_BASE_URL}${link.startsWith("/") ? "" : "/"}${link}`;
  }

  let objUserTk: any;
  if (localStorage.getItem("token")) {
    objUserTk = jwtDecode(localStorage.getItem("token") || "") as any;
  } else {
    objUserTk = {};
  }
  const isMasterOrComum = objUserTk.Rule === "Master" || objUserTk.Rule === "Comum";

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.document) {
      showToast("info", "Preencha o CNPJ");
      return;
    }
    if (!formData.productId) {
      showToast("info", "Selecione um produto");
      return;
    }
    setLoading(true);
    const apiUrl = process.env.REACT_APP_API_URL;
    setShowModal(true);
    try {
      const formDataResq = new FormData();
      if (file) {
        formDataResq.append("file", file);
      }

      formDataResq.append("idProduct", formData.productId);
      formDataResq.append("cnpj", formData.document);
      formDataResq.append("idClient", objUserTk.IdClient);

      const response = await axios.post(`${apiUrl}/N8N/uploadDocument`, formDataResq, {
        headers: {
          Authorization: objUserTk.token,
          Appkey: objUserTk.Appkey,
        },
      });

      if (response.data) {
        const dataJson = JSON.parse(response.data.json);

        setIsApto(response.data.apto?.dados?.recommendation);
        setCreditCardLimit(response.data.apto?.dados?.creditCardLimit);
        setReasonrejected(response.data.apto?.dados?.reasonForFailing);
        setMensagemAtencao(dataJson.mensagem ?? null);
        setProtocol(response.data.apto.protocolo ?? "");

        const representantes = dataJson.empresa?.representante ?? [];
        const novosSignatarios = representantes.map((rep: any) => ({
          cpf: rep.cpf || "",
          name: rep.nome || "",
          email: "",
          telefone: "",
          representanteLegal: rep.representanteLegal ?? false,
        }));

        setFormData((prevState) => ({
          ...prevState,
          signatories: novosSignatarios,
        }));
      }
    } catch (err) {
      console.log(err, "error");
      if (axios.isAxiosError(err) && err.response) {
        const apiError: ApiErrorResponse = {
          instance: err.response.data.instance,
          status: err.response.status,
          title: err.response.data.title,
          errors: err.response.data,
        };
        swal({
          title: "Falha na requisição",
          text: JSON.stringify(apiError.errors, null, 2),
          icon: "error",
        });
      }
    } finally {
      setLoading(false);
      setShowModal(false);
    }
  };

  const handleSubmitSignatarios = async (mode: DeliveryMode) => {
    setLoading(true);

    try {
      const clientId = selectedClient?.id;
      const productId = formData.productId;

      const wantsJourney = mode === "whatsapp";
      if (wantsJourney) {
        const hasJourney = await checkJourneyExists(clientId, Number(productId));
        if (!hasJourney) {
          showToast("info", "Nenhuma jornada configurada para este cliente e produto.");
          setLoading(false);
          return;
        }
      }

      const apiUrl = process.env.REACT_APP_API_URL;
      const payload: any = {
        Signatories: formData.signatories?.map((signatario) => ({
          Cpf: signatario.cpf,
          Name: signatario.name,
          Email: signatario.email,
          Phone: signatario.telefone,
          RepresentanteLegal: signatario.representanteLegal,
        })),
        Protocolo: protocol,
        IdProduct: formData.productId,
        DeliveryMode: mode,
        ...(mode !== "screen" ? { TypeJourney: mode === "whatsapp" } : {}),
      };

      const response = await axios.post(`${apiUrl}/Orchestrator/analyzePartners`, payload, {
        headers: {
          Authorization: objUserTk.token,
          Appkey: objUserTk.Appkey,
        },
      });

      if (response.data) {
        setIsAptoPartners(response.data.dados);

        if (mode === "screen") {
          const link =
            response.data?.link ??
            response.data?.url ??
            response.data?.dados?.link ??
            response.data?.dados?.url ??
            null;

          if (link) {
            const fullLink = toFullLink(link);
            setGeneratedLink(fullLink);
            setShowLinkModal(true);
          } else {
            showToast("warning", "A API não retornou um link para exibir na tela.");
          }
        }
      }
    } catch (err) {
      console.log(err, "error");
      if (axios.isAxiosError(err) && err.response) {
        const apiError: ApiErrorResponse = {
          instance: err.response.data.instance,
          status: err.response.status,
          title: err.response.data.title,
          errors: err.response.data,
        };
        swal({
          title: "Falha na requisição",
          text: JSON.stringify(apiError.errors, null, 2),
          icon: "error",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleBeforeSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setShowSelectModal(true);
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddSignatario = () => {
    setFormData((prev) => ({
      ...prev,
      signatories: [...(prev.signatories || []), { cpf: "", name: "", telefone: "", email: "" }],
    }));
  };

  const handleChangeSignatario = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => {
      const updatedSignatarios = [...(prevFormData.signatories || [])];

      if (!updatedSignatarios[index]) {
        updatedSignatarios[index] = { cpf: "", name: "", telefone: "", email: "" };
      }
      //@ts-ignore
      updatedSignatarios[index][name] = value;

      return {
        ...prevFormData,
        signatories: updatedSignatarios,
      };
    });
  };

  const handleRemoveSignatario = (indexToRemove: number) => {
    setFormData((prev) => ({
      ...prev,
      signatories: prev.signatories?.filter((_, index) => index !== indexToRemove),
    }));
  };

  function handleProductTyping(text: string) {
    setProductName(text);
  }

  function handleProductSelect(prod: any) {
    setProductName(prod.description);
    setSelectedProduct(prod);

    setFormData((prev) => ({
      ...prev,
      productId: prod.id,
    }));
  }

  const handleChangeSignatarioCheckbox = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const { checked } = e.target;

    setFormData((prevState: any) => {
      const updatedSignatories = [...prevState.signatories];
      updatedSignatories[index].representanteLegal = checked;
      return {
        ...prevState,
        signatories: updatedSignatories,
      };
    });
  };

  const normalizePhone = (tel: string | undefined) => (tel ?? "").replace(/\D/g, "");

  const handleVerifyPhone = async () => {
    setLoadingPhone(true);

    try {
      const apiUrl = process.env.REACT_APP_API_URL;

      const payload = formData.signatories?.map((sig) => ({
        document: sig.cpf,
        protocol: protocol,
        telephone: sig.telefone,
      }));

      const { data } = await axios.post(`${apiUrl}/Serasa/verifyid`, payload, {
        headers: {
          Authorization: objUserTk.token,
          Appkey: objUserTk.Appkey,
          "Content-Type": "application/json",
        },
      });

      const warnings: string[] = [];

      const hotlineObj = data.reduce((acc: any, item: any) => {
        const hotline = item.distinct;
        const informedPhone = formData.signatories?.find((s) => s.cpf === item.cpf)?.telefone;

        if (
          hotline !== "Não encontrado" &&
          informedPhone &&
          normalizePhone(hotline) !== normalizePhone(informedPhone)
        ) {
          warnings.push(
            `Telefone informado ${informedPhone} para CPF ${item.cpf} diferente do Hotline ${formatPhone(hotline)}.`
          );
        }

        if (hotline !== "Não encontrado") {
          acc[item.cpf] = hotline;
        } else if (!acc[item.cpf]) {
          acc[item.cpf] = "Não encontrado";
        }
        return acc;
      }, {});

      setHotlineResults(hotlineObj);
      setPhoneWarnings(warnings);
      setPhoneChecked(true);
    } catch (err) {
      console.error("Erro ao verificar telefone", err);
      swal({
        title: "Erro na verificação do telefone",
        text: "Não foi possível concluir a análise do telefone.",
        icon: "error",
      });
    } finally {
      setLoadingPhone(false);
    }
  };

  const clearFields = () => {
    setProtocol("");
    setClientName("");
    setSelectedClient("");
    setProductName("");
    setSelectedProduct("");
    setIsApto("");
    setCreditCardLimit("");
    setReasonrejected("");
    setIsAptoPartners("");
    setMensagemAtencao("");
    setFile(null);
    setFormData(initialFormData);
    setPhoneWarnings([]);
    setPhoneChecked(false);
    setHotlineResults({});
    setGeneratedLink(null);
    setShowLinkModal(false);
  };

  useEffect(() => {
    if (isMasterOrComum) {
      setSelectedClient({
        id: objUserTk.idClient,
        corporateName: "",
      });
      setProductName("");
      setSelectedProduct(null);
    }
  }, [isMasterOrComum, objUserTk.idClient]);

  return (
    <div>
      <div>
        <form onSubmit={isApto === "Apto" ? handleBeforeSubmit : handleSubmit}>
          <label
            htmlFor="fileInput"
            style={{ display: "block", fontWeight: "600", marginBottom: "8px" }}
          >
            Selecione ou arraste o documento:
          </label>
          <div
            onClick={() => document.getElementById("fileInput")?.click()}
            style={{
              border: "2px dashed #78E01D",
              borderRadius: "12px",
              padding: "20px",
              textAlign: "center",
              cursor: "pointer",
              backgroundColor: "#f9f9f9",
              color: "#666",
              marginBottom: "16px",
              transition: "all 0.3s ease",
            }}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                setFile(e.dataTransfer.files[0]);
              }
            }}
          >
            <FaSearchIcon style={{ color: "#78E01D", marginBottom: "8px" }} />
            <p style={{ margin: 0 }}>
              {file ? <strong style={{ color: "#333" }}>{file.name}</strong> : "Clique ou arraste um arquivo aqui"}
            </p>
            <small style={{ color: "#999" }}>(PDF)</small>
          </div>
          <input
            id="fileInput"
            type="file"
            accept=".pdf"
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                setFile(e.target.files[0]);
                e.target.value = "";
              }
            }}
            style={{ display: "none" }}
          />

          <div className="row">
            <div className="col-md-4 form-group">
              {objUserTk.Rule === "Master4Axon" && (
                <AutoCompleteClient
                  label="Cliente:"
                  value={clientName}
                  onChange={(v) => {
                    setClientName(v);
                    setSelectedClient(null);
                  }}
                  onSelect={(cli) => {
                    setClientName(cli.corporateName);
                    setSelectedClient(cli);
                    setProductName("");
                    setSelectedProduct(null);
                  }}
                />
              )}
            </div>

            <div className="col-md-4 form-group">
              <AutoCompleteProduct
                label="Produto:*"
                clientId={selectedClient?.id ?? (isMasterOrComum ? objUserTk.IdClient : null)}
                value={productName}
                onChange={handleProductTyping}
                onSelect={handleProductSelect}
              />
            </div>
            <div className="col-md-4 form-group">
              <StyledLabel>CNPJ:*</StyledLabel>
              <Cleave
                options={{ delimiters: [".", ".", "/", "-"], blocks: [2, 3, 3, 4, 2], numericOnly: true }}
                name="document"
                value={formData.document}
                onChange={handleChange}
                className="form-control"
                style={{ borderRadius: "15px", padding: "10px" }}
              />
            </div>
          </div>

          {isApto && (
            <div
              className="mt-4 p-3 d-flex justify-content-between align-items-center"
              style={{
                backgroundColor: isApto === "Apto" ? "#d4edda" : "#f8d7da",
                border: `1px solid ${isApto === "Apto" ? "#c3e6cb" : "#f5c6cb"}`,
                color: isApto === "Apto" ? "#155724" : "#721c24",
                borderRadius: "8px",
                fontWeight: "bold",
              }}
            >
              <span>
                {isApto === "Apto"
                  ? "CNPJ Apto para continuar a análise!"
                  : `CNPJ Não Apto. Fluxo encerrado. Razão por falhar: ${reasonRejected}`}
              </span>
              <span style={{ marginLeft: "auto" }}>
                Limite Aprovado:{" "}
                {creditCardLimit
                  ? Number(creditCardLimit).toLocaleString("pt-BR", { minimumFractionDigits: 2 })
                  : "0,00"}
              </span>
            </div>
          )}

          {mensagemAtencao && (
            <div
              className="mt-3 p-3"
              style={{
                backgroundColor: "#fff3cd",
                border: "1px solid #ffeeba",
                color: "#856404",
                borderRadius: "8px",
                fontWeight: "bold",
              }}
            >
              {mensagemAtencao}
            </div>
          )}

          <>
            <div className="row mt-3"></div>
            {isApto === "Apto" && (
              <>
                {formData.signatories?.map((signatario, index) => (
                  <div className="border rounded p-3 mb-4" key={index} style={{ backgroundColor: "#f9f9f9" }}>
                    <div className="row">
                      <div className="col-md-2 form-group">
                        <StyledLabel>CPF (Signatário {index + 1}):*</StyledLabel>
                        <Cleave
                          options={{ delimiters: [".", ".", "-"], blocks: [3, 3, 3, 2], numericOnly: true }}
                          style={{ borderRadius: "15px", padding: "10px" }}
                          className="form-control"
                          type="text"
                          name="cpf"
                          value={signatario.cpf}
                          onChange={(e) => handleChangeSignatario(e, index)}
                        />
                      </div>

                      <div className="col-md-3 form-group">
                        <StyledLabel>Nome (Signatário {index + 1}):</StyledLabel>
                        <input
                          style={{ borderRadius: "15px", padding: "10px" }}
                          className="form-control"
                          type="text"
                          name="name"
                          value={signatario.name}
                          onChange={(e) => handleChangeSignatario(e, index)}
                        />
                      </div>

                      <div className="col-md-3 form-group">
                        <StyledLabel>E-mail:</StyledLabel>
                        <input
                          style={{ borderRadius: "15px", padding: "10px" }}
                          className="form-control"
                          type="email"
                          name="email"
                          value={signatario.email}
                          onChange={(e) => handleChangeSignatario(e, index)}
                        />
                      </div>

                      <div className="col-md-2 form-group">
                        <StyledLabel>Telefone:</StyledLabel>
                        <Cleave
                          options={{ delimiters: ["(", ")", " ", "-", ""], blocks: [0, 2, 5, 4], numericOnly: true }}
                          style={{ borderRadius: "15px", padding: "10px" }}
                          className="form-control"
                          type="text"
                          name="telefone"
                          value={signatario.telefone}
                          onChange={(e) => handleChangeSignatario(e, index)}
                        />
                      </div>
                      <div className="col-md-2 form-group mt-3">
                        <StyledLabel>Rep. Legal:</StyledLabel>
                        <div className="form-check d-flex align-items-center" style={{ gap: "9px" }}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="representanteLegal"
                            checked={signatario.representanteLegal}
                            onChange={(e) => handleChangeSignatarioCheckbox(e, index)}
                          />
                          <span>Sim</span>
                        </div>
                      </div>

                      <div className="flex col-md-12">
                        <div className="col-md-3">
                          <StyledLabel>Hotline Bureau:</StyledLabel>
                          <input
                            style={{ borderRadius: "15px", padding: "10px" }}
                            className="form-control"
                            type="text"
                            value={formatPhone(hotlineResults?.[signatario.cpf]) || ""}
                            disabled
                          />
                        </div>
                        {phoneWarnings.length > 0 && (
                          <small className="text-warning d-flex align-items-center gap-1 mt-1">
                            <i className="bi bi-exclamation-triangle-fill" /> {formatPhone(phoneWarnings[0])}
                          </small>
                        )}
                      </div>

                      <button
                        type="button"
                        onClick={() => handleRemoveSignatario(index)}
                        className="btn btn-danger p-0 d-none d-md-flex align-items-center justify-content-center"
                        style={{
                          borderRadius: "50%",
                          width: "36px",
                          height: "36px",
                          fontSize: "22px",
                          lineHeight: "1",
                          position: "absolute",
                          right: "56px",
                          marginTop: "30px",
                        }}
                        title="Remover signatário"
                      >
                        <span>×</span>
                      </button>
                    </div>
                  </div>
                ))}

                <div className="row">
                  <div className="col-md-12">
                    <Button
                      type="button"
                      onClick={handleAddSignatario}
                      style={{ backgroundColor: "#6c757d", borderColor: "#6c757d", marginTop: "10px" }}
                    >
                      + Signatário
                    </Button>
                  </div>
                </div>

                {isAptoPartners && (
                  <div
                    className="mt-4 p-3"
                    style={{
                      backgroundColor:
                        isAptoPartners === "Apto" || isAptoPartners?.recommendation === "Apto"
                          ? "#d4edda"
                          : isAptoPartners?.recommendation === "Processando"
                            ? "#d4edda"
                            : "#f8d7da",
                      border: `1px solid ${isAptoPartners === "Apto" || isAptoPartners?.recommendation === "Apto"
                        ? "#c3e6cb"
                        : isAptoPartners?.recommendation === "Processando"
                          ? "#c3e6cb"
                          : "#f5c6cb"
                        }`,
                      color:
                        isAptoPartners === "Apto" || isAptoPartners?.recommendation === "Apto"
                          ? "#155724"
                          : isAptoPartners?.recommendation === "Processando"
                            ? "#155724"
                            : "#721c24",
                      borderRadius: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    {isAptoPartners === "Apto" || isAptoPartners?.recommendation === "Apto"
                      ? "Sócios Aptos!"
                      : isAptoPartners?.recommendation === "Processando"
                        ? "Link de verificação enviado!"
                        : "Sócios Não Aptos!"}
                  </div>
                )}
              </>
            )}
          </>

          <div className="row mt-4">
            <div className="d-flex justify-content-between">
              <Button
                onClick={clearFields}
                style={{ backgroundColor: "#6c757d", borderColor: "#6c757d", marginTop: "10px" }}
              >
                Limpar
              </Button>

              <div>
                {isApto === "Apto" && (
                  <Button
                    type="button"
                    variant="primary"
                    disabled={loadingPhone}
                    style={{ backgroundColor: "#1D9EE0", borderColor: "#1D9EE0", fontWeight: 500, marginRight: "10px" }}
                    onClick={handleVerifyPhone}
                  >
                    {loadingPhone ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Analisando Telefone...
                      </>
                    ) : (
                      "Analisar Telefone"
                    )}
                  </Button>
                )}

                <Button
                  type="submit"
                  variant="primary"
                  disabled={loading || (!phoneChecked && isApto === "Apto")}
                  style={{ backgroundColor: "#78E01D", borderColor: "#78E01D", fontWeight: 500 }}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {isApto === "Apto" ? "Analisando Sócios..." : "Analisando CNPJ..."}
                    </>
                  ) : isApto === "Apto" ? (
                    "Analisar Sócios"
                  ) : (
                    "Analisar CNPJ"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <Modal show={showSelectModal} onHide={() => setShowSelectModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold fs-5">⚙️ Forma de envio do link</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="text-muted text-center mb-4">Como você deseja realizar a análise dos sócios?</p>

          <div className="d-flex flex-column gap-3">
            <Button
              variant="outline-primary"
              size="lg"
              className="fw-semibold w-100"
              onClick={() => {
                setShowSelectModal(false);
                handleSubmitSignatarios("sms");
              }}
            >
              🔍 Receber por SMS
            </Button>

            <Button
              variant="success"
              size="lg"
              className="fw-semibold w-100"
              onClick={() => {
                setShowSelectModal(false);
                handleSubmitSignatarios("whatsapp");
              }}
            >
              🚀 Receber por WhatsApp
            </Button>

            <Button
              variant="secondary"
              size="lg"
              className="fw-semibold w-100"
              onClick={() => {
                setShowSelectModal(false);
                handleSubmitSignatarios("screen");
              }}
            >
              🔗 Mostrar link na tela
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showLinkModal} onHide={() => setShowLinkModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold fs-5">Link de verificação</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {generatedLink ? (
            <div className="d-flex flex-column gap-3">
              <div className="input-group">
                <input className="form-control" value={generatedLink} readOnly style={{ borderRadius: 10 }} />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => {
                    try {
                      navigator?.clipboard?.writeText(generatedLink);
                      showToast("success", "Link copiado para a área de transferência.");
                    } catch {
                    }
                  }}
                >
                  Copiar
                </button>
                <a className="btn btn-success" href={generatedLink} target="_blank" rel="noreferrer">
                  Abrir
                </a>
              </div>
              <small className="text-muted">Use este link para concluir a verificação manual dos sócios.</small>
            </div>
          ) : (
            <p className="text-muted mb-0">Nenhum link retornado pela API.</p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ConsultForm;